var baseURL = window.location.hostname.endsWith("sharmusic.com") ? 'https://safepay.sharmusic.com/20204' : 'https://testing.safepay.sharmusic.com/20204';
async function checkApplyGift(){
    return new Promise(function(resolve, reject) {
        var flag = true;
        var userid = document.getElementById("userid").value;
        $.ajax({
            type: "GET",
            url:baseURL + "/survey/check",
            data: {userid: userid, campaign_id: "2024_q1_pokko", sku: "POKCAL23,POKVNDD1A1,POKVNDD1A2,POKVNDD1B1,POKVNDD1B2,POKVNDD1B3,POKVNDD1C1,POKVNDD1C2,POKVNDD1D1,POKVNDD1D2,POKVNDD1D3,POKVNDD1D4,POKVNDD1D5"},
            success: function(res){
                console.log(res);
                if(res.code == "ok" && !res.data.existed) {
                    //未填
                    console.log("未领取过", res)
                    resolve(false);
                }else{
                    console.log('已领取')
                    resolve(true);
                }
            },
            error: function(err){
                console.log(err)
                resolve(true);
            } 
        });    
    })
}
async function checkFillout(){
    return new Promise(function(resolve, reject) {
        var flag = true;
        var userid = document.getElementById("userid").value;
        $.ajax({
            type: "GET",
            url:baseURL + "/survey/check",
            data: {userid: userid, campaign_id: "2024_q1_pokko"},
            success: function(res){
                console.log(res);
                if(res.code == "ok" && !res.data.existed) {
                    //未填
                    console.log("未填写问卷", res)
                    resolve(false);
                }else{
                    console.log('已填写')
                    resolve(true);
                }
            },
            error: function(err){
                console.log(err)
                resolve(true);
            } 
        });    
    })
}
// validate the questionnaire form 
function validateForm(event){
    var data = {
          role: "",
          instrument: [],
          time: "", 
          age: "",
          gender: ""
    };
    var isValid = true;
  
    var agreeInput = document.getElementById("agree");
    var agreeError = document.getElementById("agreeError");
    var isAgreeSelected = false;
    if(agreeInput.checked){
        isAgreeSelected = true;
    }else{
        isAgreeSelected = false;
    }
    if(isAgreeSelected){
        agreeError.textContent = "";
    }else{
        agreeError.textContent = "Please check the agreement!";
        isValid = false;
        document.getElementById("agreement").scrollIntoView({behavior: 'smooth'})
    }

    //check gender
    var genderInputs = document.getElementsByName("gender");
    var genderError = document.getElementById("genderError");
    var isGenderSelected = false;
    for (var i = 0; i < genderInputs.length; i++) {
        if (genderInputs[i].checked) {
              isGenderSelected = true;
              data.gender = genderInputs[i].value;
              break;
        }
    }
    if (!isGenderSelected) {
          genderError.textContent = "Please select an option!";
          isValid = false;
          document.getElementById("gender").scrollIntoView({behavior: 'smooth'});
      } else {
          genderError.textContent = "";
      }
      //check age
      var ageInputs = document.getElementsByName("age");
      var ageError = document.getElementById("ageError");
      var isAgeSelected = false;
      for (var i = 0; i < ageInputs.length; i++) {
          if (ageInputs[i].checked) {
              isAgeSelected = true;
              data.age = ageInputs[i].value;
              break;
          }
      }
      if (!isAgeSelected) {
          ageError.textContent = "Please select an option!";
          isValid = false;
          document.getElementById("age").scrollIntoView({behavior: 'smooth'})
      } else {
          ageError.textContent = "";
      }
  
      //check time
      var timeInputs = document.getElementsByName("learning-time");
      var timeError = document.getElementById("timeError");
      var isTimeSelected = false;
      for (var i = 0; i < timeInputs.length; i++) {
          if (timeInputs[i].checked) {
              isTimeSelected = true;
              data.time = timeInputs[i].value;
              break;
          }
      }
      if (!isTimeSelected) {
          timeError.textContent = "Please select an option!";
          isValid = false;
          document.getElementById("time").scrollIntoView({behavior: 'smooth'})
      } else {
          timeError.textContent = "";
      }
  
      //check instrument
      var instrumentInputs = document.getElementsByName("instrument");
      var instrumentError = document.getElementById("instrumentError");
      var isInstrumentSelected = false;
      for(var i=0; i < instrumentInputs.length; i++){
          if(instrumentInputs[i].checked){
              isInstrumentSelected = true;
              data.instrument.push(instrumentInputs[i].value);
          }
      }
      if(!isInstrumentSelected){
          instrumentError.textContent = "Please select an option!";
          isValid = false;
          document.getElementById("instrument").scrollIntoView({behavior: 'smooth'})
      } else {
          instrumentError.textContent = "";
      }
      
      // check role
      var roleInputs = document.getElementsByName("role");
      var roleError = document.getElementById("roleError");
      var isRoleSelected = false;
      for (var i = 0; i < roleInputs.length; i++) {
          if (roleInputs[i].checked) {
              isRoleSelected = true;
              data.role = roleInputs[i].value;
              break;
          }
      }
      if (!isRoleSelected) {
          roleError.textContent = "Please select an option!";
          isValid = false;
          document.getElementById("role").scrollIntoView({behavior: 'smooth'})
      } else {
          roleError.textContent = "";
      }
      console.log({data, isValid})
      return {data, isValid}
  
  }

// check whether the customer login
function tologinLandingPage(){
    sessionStorage.setItem("landing_url","/pages/questionnaire");
    window.location.href = "/account/login";
}
function tologinblackfridayPage(){
    sessionStorage.setItem("landing_url","/collections/black-friday-exclusion-list-2024");
    window.location.href = "/account/login";
}
function gocheck(id){
    window.location.href = `/cart/${id}:1`;
}
// submit the questionnaire info 
function submitForm(data){
    console.log('data:', data);
    data.userid = parseInt(document.getElementById("userid").value);
    data.campaign_id = "2024_q1_pokko";
    data.agreement = 1;
    $.ajax({
        type: "POST",
        dataType: "json",
        url: baseURL + "/survey/submit",
        contentType: "application/json;charset=UTF-8",
        data: JSON.stringify(data),
        success: function(res){
            if(res.code == 'ok') {
                window.location.href = "/pages/pokko-gift";
                return true;
            }else {
                console.log(res)
                return false;
            }
        },
        error: function(err){
            console.log(err)
            return false;
        } 
    })
}

wv$("#gift-button").on("click", function(e){
    window.location.href = "/pages/questionnaire";
});
wv$("#view-black-friday").on("click", function(e){
    window.location.href = "/collections/black-friday-exclusion-list-2024";
});
wv$("#ques-btn").on('click',function (e) {
    e.preventDefault(); 
    var res = validateForm();
    if(res.isValid){
        submitForm(res.data)
    }else{
        return false;
    }
});